import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { getPageBlocks } from '../Blocks/selectors';
import { pagesByPath } from '../Pages/selectors';

const pageProgress = (state) => state.PageProgress;

export const pageProgressSelector = createSelector(
  pageProgress,
  getPageBlocks,
  pagesByPath,
  (pageProgressSummaryByPath, pageBlocksByPath, pageSummaryByPath) => {
    return pageBlocksByPath.map((blocks, pagePath) => {
      const progressContributorSections = blocks.filter(
        (b) => b && b.get('isProgressContributor')
      );
      let completed = progressContributorSections.filter((b) =>
        b.get('isCompleted')
      ).size;
      let total = progressContributorSections.size;

      if (pageSummaryByPath.getIn([pagePath, 'isCommentRequired'], false)) {
        total += 1;
        if (
          pageProgressSummaryByPath.getIn([pagePath, 'hasUserCommented'], false)
        ) {
          completed += 1;
        }
      }

      return Immutable.Map({
        completed,
        total,
      });
    });
  }
);

export const makeGetHasUserCommentedSelector = (pagePath) =>
  createSelector(pageProgress, (pageProgressSummaryByPath) => {
    return (
      pageProgressSummaryByPath &&
      pageProgressSummaryByPath.getIn([pagePath, 'hasUserCommented'], false)
    );
  });
